import React, { useState, useEffect, useRef } from 'react'
import FileDownload from 'js-file-download'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header'
import ExcelIcon from '../../../assets/icons/ic_excel.svg';
import SendIcon from '../../../assets/icons/ic_send-email.svg';
import ListItems from '../../components/shared/ListItems';
import ItemResend from '../../components/shared/ItemResend';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Search from '../../components/shared/Search';
import CustomSelect from '../../components/shared/CustomSelect';
import InputDate from '../../components/shared/InputDate';
import EmailsModal from '../../components/shared/EmailsModal';
import Modal from '../../components/shared/Modal';

import './ManifestResend.scss'
import manifestAPI from '../../api/manifestAPI';
import { useDispatch, useSelector } from 'react-redux';
import { loadingActions, filterActions } from '../../redux/actions';
import enterprisesAPI from '../../api/enterprisesAPI';
import storesAPI from '../../api/storesAPI';
import moment from 'moment';
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const ManifestResend = () => {

  const [companiesOption, setCompaniesOption] = useState([
    {
      label: 'Empresas',
      options: [],
    },
  ])
  const [storesOption, setStoresOption] = useState([
    {
      label: 'Sucursal',
      options: [],
    },
  ])
  // const [filters, setFilters] = useState({
  //   enterprises: [],
  //   stores: [],
  //   endDate: null
  // })
  const [modalSession, setModalSession] = useState(false)
  const [modalError, setModalError] = useState(false)
  const [modalReportError, setModalReportError] = useState(false)
  const [modalEmails, setModalEmails] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  // const [textSearch, setTextSearch] = useState('')
  const dispatch = useDispatch()
  const history = useHistory()
  const [selectedRow, setSelectedRow] = useState([])
  const didMounRef = useRef(false);
  // const didMounRef2 = useRef(false);
  const didMounRef3 = useRef(false);
  const [checkManifest, setCheckManifest] = useState([]);
  const [checkManifestRT, setCheckManifestRT] = useState([]);
  const [checkManifestnoRT, setCheckManifestnoRT] = useState([]);
  const filters = useSelector(state => state.filterReducer.filtersResend)

  useEffect(() => {
    fetchManifest(currentPage, perPage)
    fetchCompanies()
    fetchStores()
    // CLEAN FILTERS FROM ALL OTHER TABS
    cleanAllOtherFilters();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if (didMounRef.current) onChangePerPage(perPage);
        else didMounRef.current = true;
        // console.log(numElem);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [perPage]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (didMounRef3.current) onChangePerPage(perPage);
      else didMounRef3.current = true;
    }, 800);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [filters])

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     if(didMounRef2.current) onChangePerPage(perPage);
  //     else didMounRef2.current = true;
  //     // console.log(numElem);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timeout);  // this guarantees to run right before the next effect
  //   }
  // }, [textSearch])

  const cleanAllOtherFilters = () => {
    dispatch(filterActions.cleanHistory());
    dispatch(filterActions.cleanStates());
    dispatch(filterActions.cleanReassign());
  }

  const formatManifest = (manifests) => {
    return manifests.map(manifest => ({
      ...manifest,
      checked: checkManifest.includes(manifest.id),
    }))
  }

  const formatFilters = ({ endDate, stores, enterprises, textSearch }) => {
    const newFilters = {
      endDate: endDate && moment(endDate).format('YYYY-MM-DD'),
      stores: Array.isArray(stores) ? stores : [stores],
      enterprises: Array.isArray(enterprises) ? enterprises : [enterprises],
      textSearch
    }
    return newFilters
  }

  const fetchManifest = async (currentPage, perPage) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const { total, manifests } = await manifestAPI.getResend(currentPage, perPage, formatFilters(filters));
      console.log("datos", total, manifests)
      setRows(formatManifest(manifests));
      setTotal(total)
      setTotalPages(Math.ceil(parseInt(total) / parseInt(perPage)))
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      console.error(error);
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchCompanies = async () => {
    try {
      const companies = await enterprisesAPI.getEnterprises();
      console.log(companies, 'COMPANIES')
      const formatCompanies = companies.map(c => ({ ...c, value: c.id, label: c.name }))
      setCompaniesOption([{
        label: 'Empresas',
        options: formatCompanies,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const fetchStores = async () => {
    try {
      const stores = await storesAPI.getStores();
      console.log(stores, 'stores')
      const formatStores = stores.map(s => ({ ...s, value: s.id, label: s.name }))
      setStoresOption([{
        label: 'Sucursal',
        options: formatStores,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    fetchManifest(numPage, perPage)
  }

  const onChangePerPage = async (perPage) => {
    if (perPage <= 0) return;
    setCurrentPage(1);
    await fetchManifest(1, perPage)
  }

  const handleClickCheckbox = (row, rowIndex) => {
    const newRows = [...rows];
    newRows[rowIndex] = { ...row, checked: !newRows[rowIndex]['checked'] };
    // console.log('filas', newRows);
    setRows(newRows);
    // console.log(newRows.map(nr => nr.lpn['value']));
    const rowsUnChecked = newRows.filter(nr => !nr.checked);
    console.log('filas no asig', rowsUnChecked)
    let newCheckManifest = [...checkManifest];
    newCheckManifest.forEach((ncMani, i) => {
      const rowsUnCheckedFounded = rowsUnChecked.find(ruck => ruck['id'] === ncMani)
      const cont = newRows.filter(v => v.id === ncMani).length
      if (rowsUnCheckedFounded && cont < 2) newCheckManifest.splice(i, 1);
    });
    console.log('newCheck', newCheckManifest)
    const allUnChecked = newRows.every(v => v.checked === false)
    // console.log('todos uncheck', allUnChecked)
    let arr
    if (allUnChecked) {
      arr = []
    } else {
      arr = [...newCheckManifest, ...newRows.filter(n => n.checked && !checkManifest.includes(n.id)).map(nr => nr.id)]      
    }
    setCheckManifest(arr);
    // console.log('check manifest', checkManifest)
    console.log('arreglo', arr)
    setCheckManifestRT(newRows.filter(v => arr.includes(v.id) && v.stage === 'RT' && v.checked).map(l => l.id))
    setCheckManifestnoRT(newRows.filter(v => arr.includes(v.id) && v.stage !== 'RT' && v.checked).map(l => l.id))
    // console.log('con RT',checkManifestRT)
  }

  const checkRowsChecked = () => {
    return checkManifest.length <= 0 ? true : false;
  }

  const exportData = async (purchaseOrders, stage) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const excel = await manifestAPI.exportExcelResend(purchaseOrders, stage);
      const dateObj = new Date()
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
      const date = ('0' + dateObj.getDate()).slice(-2)
      const year = dateObj.getFullYear()
      const fileName = `reporte_manifiestos_${date}${month}${year}.xlsx`
      FileDownload(excel, fileName)
      // console.log(excel)
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      console.log(error)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      } else {
        setModalReportError(true)
      }
    }
  }

  const sendEmail = async emailsList => {
    try {
      dispatch(loadingActions.setLoading(true))
      console.log(emailsList)
      console.log(selectedRow, 'SELECTED ROW')
      if (selectedRow.length) await manifestAPI.sendEmailResend([selectedRow[0]], emailsList, selectedRow[1]);
      else {
        // await manifestAPI.sendEmailResend(checkManifest, emailsList);
        if (checkManifestRT.length) await manifestAPI.sendEmailResend(checkManifestRT, emailsList, 'RT');
        if (checkManifestnoRT.length) await manifestAPI.sendEmailResend(checkManifestnoRT, emailsList, 'noRT');
      }
      setModalEmails(false)
      setSelectedRow([])
      dispatch(loadingActions.setLoading(false))
    } catch (e) {
      console.log(e)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      <Modal
        visible={modalError}
        onClose={() => {}}
        title="No hay conexión"
        titleImage={require("../../../assets/icons/ic_disconnected.svg")}
        color="var(--ripley-salmon)"
        btn1={{
          text: "Volver",
          type: "secondary",
          onClick: () => {
            setModalError(false);
          },
        }}
        btn2={{
          text: "Reintentar",
          type: "primary",
          onClick: () => {
            setModalError(false);
            fetchManifest();
          },
        }}
      >
        <div className="modal-error">
          <p>Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <Modal
        visible={modalReportError}
        onClose={() => setModalReportError(false)}
        title="No hay conexión"
        titleImage={require("../../../assets/icons/ic_disconnected.svg")}
        color="var(--ripley-salmon)"
        btn1={{
          text: "Volver",
          type: "secondary",
          onClick: () => {
            setModalReportError(false);
          },
        }}
        btn2={{
          text: "Reintentar",
          type: "primary",
          onClick: () => {
            setModalReportError(false);
            if (checkManifestRT.length) exportData(checkManifestRT, 'RT');
            if (checkManifestnoRT.length) exportData(checkManifestnoRT, 'noRT')
          },
        }}
      >
        <div className="modal-error">
          <p>
            No se pudo descargar el reporte. Revisa tu conexión a internet e
            inténtalo de nuevo
          </p>
        </div>
      </Modal>
      <EmailsModal
        title="Reenviar manifiestos por correo"
        titleImage={require("../../../assets/icons/mail.svg")}
        visible={modalEmails}
        onClose={() => {
          setModalEmails(false);
          setSelectedRow([]);
        }}
        onFinish={(emailsList) => sendEmail(emailsList)}
      />
      <div className="manifest-resend-container">
        <Header
          title="Manifiestos"
          subtitle="Reenvío de manifiestos"
          btnTitle1="Exportar selección"
          onClickBtn1={() => {
            if (checkManifestRT.length) exportData(checkManifestRT, 'RT');
            if (checkManifestnoRT.length) exportData(checkManifestnoRT, 'noRT')
          }}
          disabledBtn1={checkRowsChecked()}
          iconBtn1={ExcelIcon}
          btnTitle2="Enviar selección"
          onClickBtn2={() => setModalEmails(true)}
          disabledBtn2={checkRowsChecked()}
          iconBtn2={SendIcon}
        // btnTitle3='Exportar todo'
        // onClickBtn3={exportAll}
        // disabledBtn3={false}
        // iconBtn3={ExcelIcon}
        />
        <div className="manifest-resend-filters">
          <div className="manifest-resend-search">
            <Search
              placeholder="Cod. Manifiesto o N° Placa"
              value={filters.textSearch}
              onChange={(text) =>
                dispatch(
                  filterActions.setResend({ ...filters, textSearch: text })
                )
              }
            />
          </div>
          <div className="manifest-resend-select company">
            <CustomSelect
              value={filters.enterprises}
              onChange={(e) =>
                dispatch(
                  filterActions.setResend({ ...filters, enterprises: e })
                )
              }
              placeholder="Empresas"
              options={companiesOption}
              multi
            />
          </div>
          <div className="manifest-resend-select location">
            <CustomSelect
              value={filters.stores}
              onChange={(e) =>
                dispatch(filterActions.setResend({ ...filters, stores: e }))
              }
              placeholder="Sucursales"
              options={storesOption}
              multi
            />
          </div>
          <div className="manifest-resend-select closeDate">
            <InputDate
              value={filters.endDate}
              handleChange={(e) =>
                dispatch(filterActions.setResend({ ...filters, endDate: e }))
              }
              label="F. Cierre"
              fullWidth
            />
          </div>
        </div>
        <div className="manifest-resend-table">
          <ListItems
            currentPage={currentPage}
            total={total}
            perPage={perPage}
            totalPages={totalPages}
            changePage={onChangePage}
            onChangePerPage={(e) => setPerPage(e.target.value)}
          >
            {rows.map((r, i) => {
              console.log(r);
              return (
                <ItemResend
                  row={r}
                  rowIndex={i}
                  onClickCheckBox={handleClickCheckbox}
                  registerDate={r.registerDate}
                  company={r.companyName || r.company}
                  storeName={r.storeName}
                  purchaseOrdersCount={r.purchaseOrdersCount}
                  onClickExport={(id) => exportData([id], r.stage)}
                  onClickSend={(id) => {
                    setSelectedRow([id, r.stage]);
                    setModalEmails(true);
                  }}
                  onClickDetail={() =>
                    history.push(`/reenvio-manifiestos/${r.id}`, {
                      manifest: r,
                    })
                  }
                />
              );
            })}
          </ListItems>
        </div>
      </div>
    </Layout>
  );
}

export default ManifestResend
